module.exports = __webpack_public_path__ + "img/coolant-level.b8c9a92f.svg";